module.exports = {"dropMenu":{"dropItem":{"change":"dropItemChange"},"menu":{"mouseout":"dropMenuMouseout","change":"dropMenuChange","click":"clickDropMenu"}},"inputBox":{"focus":"focusInput","blur":"blurInput","keyup":"keyupInput","change":"changeInput","completion":{"click":"clickCompletion","change":"completionChange"}},"tab":{"change":"tabChange"},"checkbox":{"change":"checkboxChange"},"btn":{"click":"clickBtn"},"common":{"searchTool":{"change":"searchQueryChange"}},"selectCity":{"selectCitys":"selectCitys"},"dateTime":{"change":"dateTimeChange"},"upload":{"change":"uploadChange"}}


//////////////////
// WEBPACK FOOTER
// ./src/common/components/config/event.json
// module id = 11
// module chunks = 2